/* eslint-disable react/jsx-filename-extension, react/static-property-placement */
import React from 'react';
import PropTypes from 'prop-types';
import ArticleMediaIcon from './article-media-icon';

/**
 * A React component for an article image in an article list, and the analog
 * to the PHP template part `img.php`.
 */
export default class ArticleImg extends React.PureComponent {
  static propTypes = {
    src: PropTypes.string.isRequired,
    alt_text: PropTypes.string,
    srcset: PropTypes.string,
    sizes: PropTypes.string,
    orientation: PropTypes.string,
    proportions: PropTypes.string,
    context: PropTypes.string,
    leadMedia: PropTypes.shape({
      format: PropTypes.string,
      raw: PropTypes.string,
      type: PropTypes.string,
    }).isRequired,
    mediaTypeIcon: PropTypes.shape({
      name: PropTypes.string,
      label: PropTypes.string,
    }).isRequired,
  };

  static defaultProps = {
    alt_text: '',
    srcset: '',
    sizes: '',
    orientation: '',
    proportions: '',
    context: '',
  };

  /**
   * Determine image class attribute based on image orientation and context.
   * The class is mainly used as a hook for applying an intrinsic sizing wrapper
   * to <img> tags.
   *
   * This follows the non-react version: `Nexstar\get_orientation_class`.
   *
   * @see Nexstar\get_orientation_class()
   *
   * @returns {String} image classes.
   */
  getOrientationClass() {
    const classes = [];
    const { orientation, proportions, context } = this.props;

    if (orientation) {
      classes.push(orientation); // assign portrait, landscape or square.
    }

    // Target square images where the ratio has been changed via media context.
    if (proportions && '1:1' === proportions) {
      classes.pop(); // remove previously assigned orientation class.
      classes.push('square'); // context ratio is square. label as a square.
    }

    // Media Grid 3-column context only.
    if (context && 0 === context.indexOf('three_col_media_grid')) {
      classes.push('square-on-mobile');
    }

    // Promotional context only.
    if (
      context
      && context.includes('promotional')
      && ! classes.includes('landscape')
    ) {
      classes.push('landscape');
    }

    // Media Grid 4-column context only.
    if (
      context
      && context.includes('four_col_media_grid')
      && ! classes.includes('landscape')
      && ! classes.includes('square')
      && ! classes.includes('portrait')
    ) {
      classes.push('landscape'); // context in four_col_media_grid works with landscape.
    }

    return classes.join(' ');
  }

  /**
   * Determine "loading" attribute of the article image tag based on context.
   *
   * This follows the non-react version: `Nexstar\img_loading_attr`.
   *
   * @returns {String} "loading" attribute.
   */
  getImgLoadingAttr() {
    const { context } = this.props;
    let loadingAttr = 'lazy';
    if (context.includes('hero')) {
      loadingAttr = 'eager';
    }

    return loadingAttr;
  }

  render() {
    const {
      src,
      alt_text: alttext,
      mediaTypeIcon,
      srcset,
      sizes,
    } = this.props;

    return (
      <>
        <div className="article-list__article-image-wrapper">
          <div className={`image-wrapper ${this.getOrientationClass()}`}>
            {(srcset) ? (
              <img
                src={src}
                alt={alttext}
                srcSet={srcset}
                sizes={sizes}
                loading={this.getImgLoadingAttr()}
              />
            ) : (
              <img
                src={src}
                alt={alttext}
                loading={this.getImgLoadingAttr()}
              />
            )}
          </div>
          <ArticleMediaIcon mediaTypeIcon={mediaTypeIcon} />
        </div>
      </>
    );
  }
}
